import React, { useState, useEffect, useCallback } from 'react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Handshake, ExternalLink, Landmark, GraduationCap, Percent, ArrowRight, MessageCircle, ChevronLeft, ChevronRight, Award } from 'lucide-react';

const partners = [
  {
    name: 'Tekto',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/2ab7p11t_image.png',
    url: 'https://tekto.com.br/',
    description: 'Solução para aprovação automatizada de projetos em BIM para prefeituras e outros órgãos públicos. Sistema já em uso na cidade de Salvador, na Bahia.',
    bgColor: 'bg-white',
    textColor: 'text-orange-600',
    officialRep: true,
    type: 'partner'
  },
  {
    name: 'OrçaFascio',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/qaxin71d_image.png',
    url: 'https://orcafascio.com/',
    description: 'Uma das principais plataformas de orçamentação 5D do mercado, com interface direta com o Revit.',
    bgColor: 'bg-white',
    textColor: 'text-blue-600',
    type: 'partner'
  },
  {
    name: 'YouBIM',
    logo: '/logos/youbim.png',
    url: 'https://youbim.com/',
    description: 'Plataforma BIM para gestão de ativos e facilities.',
    bgColor: 'bg-white',
    textColor: 'text-cyan-600',
    officialRep: true,
    type: 'partner'
  },
  {
    name: 'Marcia Dóring Consultoria',
    logo: '/logos/marcia-doring.png',
    url: 'https://www.marciadoringconsultoria.com/',
    description: 'Serviços de consultoria com ênfase na experiência em Gerenciamento de Projetos, com base no PMBOK. Ou seja: não implemente sem antes implantar; e, ao implantar, busque as informações corretas para decidir a melhor implementação.',
    bgColor: 'bg-white',
    textColor: 'text-indigo-700',
    type: 'partner'
  },
  {
    name: 'FABIM',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/e1mdk0ru_Original%20on%20transparent.webp',
    url: 'https://www.projetabim.com.br/',
    description: 'Planejamento e Gestão de Obras: atua com Planejamento Inteligente para obras mais lucrativas.',
    bgColor: 'bg-white',
    textColor: 'text-slate-600',
    type: 'partner'
  },
  {
    name: 'Advance Corporation',
    logo: 'https://static.prod-images.emergentagent.com/jobs/2b41e164-3d6f-488e-a974-c4593600dbb3/images/7a63ba1be99dd502643644cc527807d0e0fe8955aca24847d118614431fbf222.jpeg',
    url: null,
    description: 'Construtora e incorporadora parceira da AJ | BIM Projetos, responsável por empreendimentos como o Mirante Águas Lindas.',
    bgColor: 'bg-white',
    textColor: 'text-slate-700',
    type: 'partner'
  },
  {
    name: 'Guilherme Guignone',
    logo: 'https://static.prod-images.emergentagent.com/jobs/2b41e164-3d6f-488e-a974-c4593600dbb3/images/e0ceb4cf93c718dadb74b883e22e60ef46143b5ceb9b5b6eeb2a5917368bae6d.jpeg',
    url: 'https://guilhermeguignone.com.br/',
    description: 'Especialista em projetos de infraestrutura, utilizando ferramentas BIM como Civil 3D e Navisworks.',
    bgColor: 'bg-white',
    textColor: 'text-green-700',
    type: 'partner'
  },
  {
    name: 'Prospecad',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/xdb697v3_WhatsApp%20Image%202026-08-12%20at%2019.16.05.jpeg',
    url: 'https://www.instagram.com/prospecad_bim_infra/',
    description: 'Projetos e treinamentos em BIM voltados para infraestrutura.',
    bgColor: 'bg-white',
    textColor: 'text-slate-700',
    type: 'partner'
  },
  {
    name: 'Conexão BIM',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/stlmg8cm_conexaobim.png',
    url: 'https://conexaobim.com.br/',
    description: 'Disseminando o BIM pelo Brasil.',
    bgColor: 'bg-white',
    textColor: 'text-orange-600',
    type: 'partner'
  },
  {
    name: 'Brain Builder',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/0ujrvht6_bbcep.webp',
    url: 'https://www.bbcep.eng.br/',
    description: 'Cursos de extensão profissional nas áreas de engenharia, tecnologia e construção.',
    bgColor: 'bg-white',
    textColor: 'text-orange-600',
    type: 'partner'
  },
  {
    name: 'Vértice Academy',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/wc0uji67_logo.png',
    url: 'https://www.verticeacademy.com.br/',
    description: 'Capacitação e treinamentos em BIM e tecnologia aplicados à construção.',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'partner'
  },
  {
    name: 'genia',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/71lbe87v_image.png',
    url: 'https://geniainnovation.com/',
    description: 'Inovação e tecnologia aplicadas à construção e ao BIM.',
    bgColor: 'bg-white',
    textColor: 'text-blue-600',
    type: 'partner'
  },
  {
    name: 'OpenProject BIM',
    logo: 'https://static.prod-images.emergentagent.com/jobs/2b41e164-3d6f-488e-a974-c4593600dbb3/images/90e45d2b45d851b382c853e23b8022b64d4fca37edca94ce04c3f49b91b9c3a0.jpeg',
    url: 'https://www.openproject.org/bim-project-management/',
    description: 'Gestão de projetos BIM open source, com colaboração via BCF, coordenação de modelos IFC e gestão de tarefas.',
    bgColor: 'bg-white',
    textColor: 'text-slate-800',
    officialRep: true,
    type: 'partner'
  }
];

const agreements = [
  {
    name: 'CAU/SC',
    logo: null,
    url: 'https://www.causc.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo de Santa Catarina',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'agreement'
  },
  {
    name: 'CAU/GO',
    logo: '/logos/cau-go-oficial.png',
    url: 'https://www.caugo.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo de Goiás',
    bgColor: 'bg-white',
    cardBg: '#41696F',
    textColor: 'text-blue-700',
    formalized: true,
    type: 'agreement'
  },
  {
    name: 'CAU/AL',
    logo: '/logos/cau-al-oficial.png',
    url: 'https://www.caual.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo de Alagoas',
    bgColor: 'bg-white',
    cardBg: '#41696F',
    textColor: 'text-blue-700',
    formalized: true,
    type: 'agreement'
  },
  {
    name: 'CAU/RJ',
    logo: null,
    url: 'https://www.caurj.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo do Rio de Janeiro',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'agreement'
  },
  {
    name: 'CAU/MT',
    logo: null,
    url: 'https://www.caumt.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo de Mato Grosso',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'agreement'
  },
  {
    name: 'CAU/CE',
    logo: null,
    url: 'https://www.cauce.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo do Ceará',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'agreement'
  },
  {
    name: 'CAU/AM',
    logo: null,
    url: 'https://www.cauam.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo do Amazonas',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'agreement'
  },
  {
    name: 'CAU/DF',
    logo: null,
    url: 'https://www.caudf.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo do Distrito Federal',
    bgColor: 'bg-white',
    cardBg: '#41696F',
    textColor: 'text-blue-700',
    formalized: true,
    type: 'agreement'
  },
  {
    name: 'CBIM Nacional',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/w1cg1ntr_24-03-BIM-Forum-Brasil-Site-2.10-Sobre-Parceiros_CBIM.png',
    url: 'https://www.cbim.org.br/',
    description: 'Câmara Brasileira de BIM — associação que fomenta o BIM no Brasil',
    bgColor: 'bg-white',
    cardBg: '#ffffff',
    textColor: 'text-slate-700',
    formalized: true,
    association: true,
    type: 'agreement'
  },
  {
    name: 'CBIM MG',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/05z6pyw2_images.png',
    url: 'https://www.cbim.org.br/',
    description: 'Câmara Brasileira de BIM — Minas Gerais',
    bgColor: 'bg-white',
    cardBg: '#ffffff',
    textColor: 'text-slate-700',
    formalized: true,
    association: true,
    type: 'agreement'
  },
  {
    name: 'SINAENCO',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/f8i4i9ju_sinaenco.png',
    url: 'https://sinaenco.com.br/',
    description: 'Sindicato Nacional das Empresas de Arquitetura e Engenharia Consultiva',
    bgColor: 'bg-white',
    cardBg: '#ffffff',
    textColor: 'text-slate-700',
    formalized: true,
    association: true,
    type: 'agreement'
  },
  {
    name: 'CAU/ES',
    logo: null,
    url: 'https://www.caues.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo do Espírito Santo',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'agreement'
  },
  {
    name: 'CAU/SP',
    logo: null,
    url: 'https://www.causp.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo de São Paulo',
    bgColor: 'bg-white',
    textColor: 'text-blue-700',
    type: 'agreement'
  },
  {
    name: 'CREA/AL',
    logo: 'https://customer-assets.emergentagent.com/job_8576f24b-c947-4590-9ecd-203cfcfcb7b8/artifacts/expq4rhr_ALAGOAS-crea_color-500x112.png',
    url: 'https://www.crea-al.org.br/',
    description: 'Conselho Regional de Engenharia e Agronomia de Alagoas',
    bgColor: 'bg-white',
    textColor: 'text-green-700',
    formalized: true,
    type: 'agreement'
  },
  {
    name: 'CAU/MG',
    logo: 'https://customer-assets.emergentagent.com/job_8576f24b-c947-4590-9ecd-203cfcfcb7b8/artifacts/b5feutb9_CAU%20MG.png',
    url: 'https://www.caumg.gov.br/',
    description: 'Conselho de Arquitetura e Urbanismo de Minas Gerais',
    bgColor: 'bg-white',
    cardBg: '#41696F',
    textColor: 'text-blue-700',
    formalized: true,
    type: 'agreement'
  },
  {
    name: 'CREA/SP',
    logo: null,
    url: 'https://www.creasp.org.br/',
    description: 'Conselho Regional de Engenharia e Agronomia de São Paulo',
    bgColor: 'bg-white',
    textColor: 'text-green-700',
    type: 'agreement'
  },
  {
    name: 'CREA/BA',
    logo: null,
    url: 'https://www.creaba.org.br/',
    description: 'Conselho Regional de Engenharia e Agronomia da Bahia',
    bgColor: 'bg-white',
    textColor: 'text-green-700',
    type: 'agreement'
  },
  {
    name: 'CREA/DF',
    logo: null,
    url: 'https://www.creadf.org.br/',
    description: 'Conselho Regional de Engenharia e Agronomia do Distrito Federal',
    bgColor: 'bg-white',
    textColor: 'text-green-700',
    type: 'agreement'
  },
  {
    name: 'CREA/GO',
    logo: null,
    url: 'https://www.creago.org.br/',
    description: 'Conselho Regional de Engenharia e Agronomia de Goiás',
    bgColor: 'bg-white',
    textColor: 'text-green-700',
    type: 'agreement'
  },
  {
    name: 'CREA/RS',
    logo: null,
    url: 'https://www.crea-rs.org.br/',
    description: 'Conselho Regional de Engenharia e Agronomia do Rio Grande do Sul',
    bgColor: 'bg-white',
    textColor: 'text-green-700',
    type: 'agreement'
  }
];

const PARTNER_CARD_BG = '#26262b';
const PARTNER_ROTATE_MS = 8000;

const PartnershipsSection = ({ show = 'all' }) => {
  const showPartners = show === 'all' || show === 'partners';
  const showAgreements = show === 'all' || show === 'agreements' || show === 'institutional';
  const hasPartners = partners.length > 0;
  const hasAgreements = agreements.length > 0;

  const caus = agreements.filter(a => a.name.startsWith('CAU'));
  const creas = agreements.filter(a => a.name.startsWith('CREA'));
  const associations = agreements.filter(a => a.association);

  const [pIndex, setPIndex] = useState(0);
  const [pPaused, setPPaused] = useState(false);
  const pCount = partners.length;
  const pGoTo = useCallback((i) => setPIndex(((i % pCount) + pCount) % pCount), [pCount]);

  useEffect(() => {
    if (pPaused || !showPartners || pCount === 0) return undefined;
    const t = setInterval(() => setPIndex((i) => (i + 1) % pCount), PARTNER_ROTATE_MS);
    return () => clearInterval(t);
  }, [pPaused, showPartners, pCount]);

  const partner = partners[pIndex] || partners[0];

  const renderAgreementCard = (agreement, index) => (
    <a
      key={agreement.name || index}
      href={agreement.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex flex-col items-center"
      data-testid={`agreement-${agreement.name.toLowerCase().replace(/\s/g, '-').replace('/', '-')}`}
    >
      {agreement.formalized ? (
        <div
          className="w-28 h-28 rounded-xl flex items-center justify-center shadow-lg hover:shadow-green-500/20 transition-all duration-300 hover:scale-105 border-2 border-transparent hover:border-green-500/50 p-3 overflow-hidden"
          style={{ backgroundColor: agreement.cardBg || '#ffffff' }}
        >
          {agreement.logo ? (
            <img
              src={agreement.logo}
              alt={agreement.name}
              className="max-w-full max-h-full object-contain"
            />
          ) : (
            <div className="flex flex-col items-center justify-center leading-none">
              <span className="text-white font-bold text-3xl tracking-tight">{agreement.name.split('/')[0]}</span>
              <span className="text-white/90 font-semibold text-xl mt-1">{agreement.name.split('/')[1]}</span>
            </div>
          )}
        </div>
      ) : (
        <div className="relative w-28 h-28 bg-zinc-800/70 rounded-xl flex flex-col items-center justify-center shadow-lg border-2 border-dashed border-zinc-600 transition-all duration-300 hover:scale-105 hover:border-amber-500/60 overflow-hidden">
          <span className="text-gray-300 font-bold text-xl leading-tight">{agreement.name.split('/')[0]}</span>
          <span className="text-gray-400 font-semibold text-base">{agreement.name.split('/')[1]}</span>
          <div className="absolute bottom-0 inset-x-0 bg-amber-500 text-black text-[10px] font-bold uppercase tracking-wide text-center py-1">
            Em breve
          </div>
        </div>
      )}
      <div className="mt-2 text-center">
        <p className="text-white text-xs font-medium group-hover:text-green-400 transition-colors flex items-center justify-center gap-1">
          {agreement.name}
          {agreement.formalized && <ExternalLink className="w-2 h-2 opacity-0 group-hover:opacity-100 transition-opacity" />}
        </p>
        {!agreement.formalized && (
          <p className="text-amber-500/80 text-[10px] mt-0.5">Em processo de formalização</p>
        )}
      </div>
    </a>
  );

  return (
    <section className="py-8 md:py-10 bg-black" data-testid="partnerships-section">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <Badge className="bg-blue-600/20 text-blue-400 border-blue-500/30 mb-4">
            <Handshake className="w-3 h-3 mr-1 inline" />
            Juntos somos mais fortes
          </Badge>
          {(show === 'agreements' || show === 'institutional') ? (
            <>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {show === 'institutional' ? (
                  <>Parceiros <span className="text-green-500">Institucionais</span></>
                ) : (
                  <>Convênios <span className="text-green-500">Institucionais</span></>
                )}
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Conselhos e instituições conveniados que garantem condições e descontos exclusivos aos seus vinculados em nossos cursos e formações BIM.
              </p>
            </>
          ) : show === 'partners' ? (
            <>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Parceiros <span className="text-blue-500">Tecnológicos</span>
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Empresas parceiras que colaboram conosco para oferecer as melhores soluções em BIM.
              </p>
            </>
          ) : (
            <>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Parcerias e <span className="text-blue-500">Convênios</span>
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Empresas e instituições parceiras que colaboram conosco para oferecer as melhores soluções em BIM.
              </p>
            </>
          )}
        </div>

        {/* Partners */}
        {showPartners && hasPartners && (
          <div className="mb-12">
            {show === 'all' && (
              <h3 className="text-xl font-semibold text-white mb-6 text-center">
                <span className="text-blue-400">Parceiros</span> Tecnológicos
              </h3>
            )}
            <div
              className="relative max-w-5xl mx-auto"
              onMouseEnter={() => setPPaused(true)}
              onMouseLeave={() => setPPaused(false)}
            >
              <div
                className="relative rounded-2xl border border-zinc-800 overflow-hidden shadow-xl"
                style={{ backgroundColor: PARTNER_CARD_BG }}
              >
                {/* Logo do parceiro + selo carimbo sobreposto (direita) */}
                <div className="absolute right-0 top-0 bottom-0 w-[40%] md:w-[36%] hidden sm:flex flex-col items-center justify-center p-6">
                  <div className="relative bg-white rounded-2xl w-full h-40 md:h-48 flex items-center justify-center p-2.5 pr-6 shadow-lg">
                    <img
                      key={partner.logo}
                      src={partner.logo}
                      alt={partner.name}
                      className="max-h-full max-w-full object-contain animate-in fade-in duration-700"
                      loading="lazy"
                    />
                    {partner.officialRep && (
                      <div
                        className="absolute -bottom-4 -right-4 w-16 h-16 md:w-20 md:h-20 rounded-full flex flex-col items-center justify-center text-center bg-[#6d1a2e] backdrop-blur-[1px] shadow-xl shadow-black/50 rotate-[-12deg] ring-2 ring-white/80 animate-in fade-in zoom-in duration-500"
                        data-testid="partner-official-seal"
                      >
                        <span className="absolute inset-[4px] rounded-full border border-dashed border-white/60"></span>
                        <Award className="w-3 h-3 md:w-3.5 md:h-3.5 text-white mb-0.5" />
                        <span className="text-white font-black tracking-tight text-[7px] md:text-[8px] leading-none">
                          AJ | BIMPORTAL
                        </span>
                        <span className="text-white/90 font-bold uppercase leading-[1.05] tracking-wide text-[5px] md:text-[6px] px-1.5 mt-0.5">
                          Representante Oficial no Brasil
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Conteúdo (esquerda) */}
                <div
                  key={pIndex}
                  className="relative p-7 md:p-12 sm:pr-[42%] md:pr-[38%] min-h-[300px] md:min-h-[320px] flex flex-col justify-center animate-in fade-in slide-in-from-bottom-2 duration-500"
                  data-testid={`partner-${partner.name.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {/* Logo + selo no mobile */}
                  <div className="sm:hidden mb-5">
                    <div className="relative bg-white rounded-xl inline-flex items-center justify-center p-2.5 h-24 min-w-[150px]">
                      <img src={partner.logo} alt={partner.name} className="max-h-full max-w-[180px] object-contain" loading="lazy" />
                      {partner.officialRep && (
                        <div className="absolute -bottom-3 -right-3 w-16 h-16 rounded-full flex flex-col items-center justify-center text-center bg-[#6d1a2e] shadow-lg rotate-[-12deg] ring-2 ring-white/70">
                          <span className="absolute inset-[4px] rounded-full border border-dashed border-white/60"></span>
                          <Award className="w-3 h-3 text-white mb-0.5" />
                          <span className="text-white font-black tracking-tight text-[7px] leading-none">
                            AJ | BIMPORTAL
                          </span>
                          <span className="text-white/90 font-bold uppercase leading-[1.05] tracking-wide text-[5px] px-1 mt-0.5">
                            Representante Oficial no Brasil
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <span className="inline-block border-2 border-blue-500 text-blue-400 rounded-full px-6 py-2 text-xs font-bold tracking-[0.15em] uppercase mb-5 w-fit">
                    Parceiro Tecnológico
                  </span>
                  <p className="text-gray-100 text-base md:text-xl leading-relaxed mb-5" data-testid="partner-description">
                    {partner.description}
                  </p>
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-bold text-white text-base md:text-lg">{partner.name}</span>
                    {partner.url && (
                      <a
                        href={partner.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-sm text-blue-400 hover:text-blue-300 transition-colors"
                      >
                        Visitar site <ExternalLink className="w-3 h-3" />
                      </a>
                    )}
                  </div>
                  <div className="mt-4 inline-flex items-start gap-2 bg-blue-500/10 border border-blue-500/30 rounded-lg px-3.5 py-2.5 w-fit" data-testid="partner-code-info">
                    <Percent className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                    <p className="text-blue-100/90 text-xs md:text-sm leading-snug">
                      Para contratação de cursos e serviços, informe o código{' '}
                      <span className="font-bold text-white tracking-wide bg-blue-600/40 rounded px-1.5 py-0.5">AJBIMPORTAL</span>
                    </p>
                  </div>
                  {partner.officialRep && (
                    <div className="mt-4 flex flex-wrap items-center gap-3">
                      <a
                        href="https://wa.me/5561995792667"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-xs font-semibold text-white bg-green-600 hover:bg-green-700 rounded-full px-3 py-1.5 transition-colors"
                        data-testid={`partner-whatsapp-${partner.name.toLowerCase().replace(/\s/g, '-')}`}
                      >
                        <MessageCircle className="w-4 h-4" />
                        Atendimento: (61) 99579-2667
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {/* Controles */}
              <div className="flex items-center justify-center gap-4 mt-6">
                <button
                  type="button"
                  onClick={() => pGoTo(pIndex - 1)}
                  aria-label="Parceiro anterior"
                  data-testid="partner-prev"
                  className="w-10 h-10 rounded-full border border-zinc-700 text-gray-300 hover:text-white hover:border-blue-500 flex items-center justify-center transition-colors"
                >
                  <ChevronLeft size={20} />
                </button>
                <div className="flex items-center gap-2">
                  {partners.map((item, i) => (
                    <button
                      key={item.name}
                      type="button"
                      onClick={() => pGoTo(i)}
                      aria-label={`Ir para parceiro ${i + 1}`}
                      data-testid={`partner-dot-${i}`}
                      className={`h-2 rounded-full transition-all ${i === pIndex ? 'w-7 bg-blue-500' : 'w-2 bg-zinc-600 hover:bg-zinc-500'}`}
                    />
                  ))}
                </div>
                <button
                  type="button"
                  onClick={() => pGoTo(pIndex + 1)}
                  aria-label="Próximo parceiro"
                  data-testid="partner-next"
                  className="w-10 h-10 rounded-full border border-zinc-700 text-gray-300 hover:text-white hover:border-blue-500 flex items-center justify-center transition-colors"
                >
                  <ChevronRight size={20} />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Agreements/Convênios */}
        {showAgreements && hasAgreements && (
          <div>
            <h3 className="text-xl font-semibold text-white mb-2 text-center">
              <span className="text-green-400">Convênios</span> Institucionais Formalizados
            </h3>
            <p className="text-gray-400 text-sm text-center mb-6">
              Condições especiais exclusivas em cursos e formações BIM
            </p>
            <div className="flex flex-wrap justify-center gap-4 max-w-6xl mx-auto">
              {caus.map((agreement, index) => renderAgreementCard(agreement, index))}
            </div>
            {creas.length > 0 && (
              <div className="flex flex-wrap justify-center gap-4 max-w-6xl mx-auto mt-6">
                {creas.map((agreement, index) => renderAgreementCard(agreement, index))}
              </div>
            )}
            {associations.length > 0 && (
              <div className="mt-10">
                <h4 className="text-base font-semibold text-white mb-1 text-center">
                  Associações e <span className="text-green-400">Sindicatos</span>
                </h4>
                <p className="text-gray-400 text-xs text-center mb-5">
                  Entidades que fomentam a disseminação do BIM no Brasil
                </p>
                <div className="flex flex-wrap justify-center gap-4 max-w-6xl mx-auto">
                  {associations.map((agreement, index) => renderAgreementCard(agreement, index))}
                </div>
              </div>
            )}
            <p className="text-gray-500 text-xs text-center mt-4">
              Clique para visitar o site oficial de cada conselho formalizado
            </p>
          </div>
        )}

        {/* Placeholder for when agreements are empty */}
        {!hasAgreements && (
          <div className="text-center mt-8 py-8 border border-dashed border-zinc-700 rounded-xl bg-zinc-900/30">
            <p className="text-gray-500 text-sm">
              Convênios institucionais serão adicionados em breve
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnershipsSection;
